// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 7947) return "static/css/7947.182a782996d52b50cd16.css";
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + "4f767f2564a62b1968c8" + ".chunk.css";
};